/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramTransactionsWebhookControllerCardComWebhookMutationRequest,
  TelegramTransactionsWebhookControllerCardComWebhookMutationResponse,
} from '../../types/TelegramTransactionsWebhookControllerCardComWebhook.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramTransactionsWebhookCardComWebhook } from '../../methods/telegramTransactionsWebhookCardComWebhook.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramTransactionsWebhookCardComWebhookMutationKey = () =>
  [{ url: '/api/telegram/transactions/webhook/cardcom' }] as const;

export type TelegramTransactionsWebhookCardComWebhookMutationKey = ReturnType<
  typeof telegramTransactionsWebhookCardComWebhookMutationKey
>;

/**
 * {@link /api/telegram/transactions/webhook/cardcom}
 */
export function useTelegramTransactionsWebhookCardComWebhook<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramTransactionsWebhookControllerCardComWebhookMutationResponse,
      ResponseErrorConfig<Error>,
      { data: TelegramTransactionsWebhookControllerCardComWebhookMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramTransactionsWebhookControllerCardComWebhookMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramTransactionsWebhookCardComWebhookMutationKey();

  return useMutation<
    TelegramTransactionsWebhookControllerCardComWebhookMutationResponse,
    ResponseErrorConfig<Error>,
    { data: TelegramTransactionsWebhookControllerCardComWebhookMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramTransactionsWebhookCardComWebhook(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
